import { Component, OnInit } from '@angular/core';
import { Gtp } from 'src/app/shared/gtp';
import { ListaMovilesService } from 'src/app/shared/services/lista-moviles.service';
import { MapToolMovil } from 'src/app/models/mapa-tool-movil';
import { MapToolsService } from 'src/app/shared/services/map-tools.service';

@Component({
  selector: 'app-tools-header',
  templateUrl: './tools-header.component.html',
  styleUrls: ['./tools-header.component.scss']
})
export class ToolsHeaderComponent implements OnInit {

  tabIrAMovil:boolean = false;
  tabCapas: boolean = false;
  tabConfig:boolean = false;
  tabPuntosCliente:boolean = false;
  tabRutas:boolean = false;
  tabBuscador:boolean = false;
  linkClose: Event;
  irAMovil: Event;
  tipoDePlan: any;

  public moviles:any=[];

  constructor(
    private movilesService: ListaMovilesService,
    private gtp: Gtp,
    private maptoolService: MapToolsService
  ) {
    let user = JSON.parse(this.gtp.getUserData());
    //this.tipoDePlan = (user.cliente_plan_id == 1) ? "planBasico" : "planFull";
    //this.tipoDePlan = (user.cliente_plan_id == 3 ) ? "planBasico" : "planFull";
    switch (user.cliente_plan_id) {
      case 1:
        this.tipoDePlan = 1
      break;
      case 2:
        this.tipoDePlan = 2
      break;
      case 3:
        this.tipoDePlan = 3
        break;
      default:
        break;
    }
  }

  ngOnInit() {
    this.getMoviles();
  }

  closeTabs(event?: Event){
    this.tabIrAMovil = false;
    this.tabCapas = false;
    this.tabConfig = false;
    this.tabPuntosCliente = false;
    this.tabRutas = false;
    this.tabBuscador = false;
    this.linkClose = event;
  }

  showTab(tab) {
    if (tab == 'iramovil') {
      this.tabIrAMovil = (this.tabIrAMovil) ? false : true;
      this.tabPuntosCliente = false;
      this.tabCapas = false;
      this.tabConfig = false;
      this.tabRutas = false;
      this.tabBuscador = false;
    }
    if (tab == 'puntoscliente') {
      this.tabPuntosCliente = (this.tabPuntosCliente) ? false : true;
      this.tabIrAMovil = false;
      this.tabCapas = false;
      this.tabConfig = false;
      this.tabRutas = false;
      this.tabBuscador = false;
    }
    if (tab == 'capas') {
      this.tabCapas = (this.tabCapas) ? false : true;
      this.tabPuntosCliente = false;
      this.tabIrAMovil = false;
      this.tabConfig = false;
      this.tabRutas = false;
      this.tabBuscador = false;
    }
    if (tab == 'config') {
      this.tabConfig = (this.tabConfig) ? false : true;
      this.tabIrAMovil = false;
      this.tabPuntosCliente = false;
      this.tabCapas = false;
      this.tabRutas = false;
      this.tabBuscador = false;
    }
    if (tab == 'rutas') {
      this.tabRutas = (this.tabRutas) ? false : true;
      this.tabIrAMovil = false;
      this.tabPuntosCliente = false;
      this.tabCapas = false;
      this.tabConfig = false;
      this.tabBuscador = false;
    }
    if (tab == 'buscador') {
      this.tabBuscador = (this.tabBuscador) ? false : true;
      this.tabIrAMovil = false;
      this.tabPuntosCliente = false;
      this.tabCapas = false;
      this.tabConfig = false;
      this.tabRutas = false;
    }
  }

  getMoviles(){
    this.movilesService.getListaMoviles().subscribe(res => {
      let lista = [];
      Object.entries(res).forEach(item => { lista.push(new MapToolMovil(item[1])); });
      this.moviles = lista.sort(this.gtp.orderMoviles);
    });
  }

  centerMap(pos) {
    this.maptoolService.setCenterMapa(pos);
  }

}
